import { render } from "./template_description.vue?vue&type=template&id=b6d30408"
import script from "./template_description.vue?vue&type=script&lang=js"
export * from "./template_description.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__